<template>
  <div class="after-payment"></div>
</template>


<script lang="js">
import { mapGetters } from 'vuex';

export default {
  name: 'AfterPayment',

  data() {
    return {
    };
  },

  computed: {
    ...mapGetters('RobokassaState', ['robokassaOrder', 'robokassaStatus']),
  },

  methods: {
    async goToOrder() {
      const invoice = this.$route.query.InvId || '';
      if (invoice) await this.getOrderByInvoiceNumber(invoice);
      if (this.robokassaStatus === 200 && this.robokassaOrder) {
        this.$router.replace({ path: `/order/${this.robokassaOrder}` }).catch(() => {});
        return;
      }

      this.$router.replace({ name: 'home' }).catch(() => {});
    },
    async getOrderByInvoiceNumber(payload) {
      return await this.$store.dispatch('RobokassaState/getOrderByInvoiceNumber', payload);
    },
  },

  async mounted() {
    await this.goToOrder();
  },
}
</script>


<style lang="scss" scoped>
  .after-payment {
    width: 100%;
    height: 100%;
    background-color: transparent;
  }
</style>